import React, { useState, useEffect, useRef } from "react";
import { toast } from "react-toastify";
import axios from "axios";
import {
  IconButton,
  MenuItem,
  Tooltip,
  Typography,
  Grid,
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableBody,
  FormControl,
  Card,
} from "@mui/material";
import {
  StyledButton,
  StyledInputLabel,
  StyledSelect,
  StyledTextField,
  StyledTableCellHistory,
  StyledTableRowHistory,
  theme,
  OutlinedIconFab,
  StyledTableContainer,
} from "../StyledComponents";
import { ThemeProvider } from "styled-components";
import SpeechRecognition, {
  useSpeechRecognition,
} from "react-speech-recognition";
import Icon from "../Utils/Icons";
import { durationType } from "../initialData/initialData";
import dayjs from "dayjs";

const AllergyIntoleranceSimplified = ({
  allergyHistoryData,
  setAllergyHistoryData,
  activeHistorySection,
  setActiveHistorySection,
  startRecording,
  stopRecording,
  isAiEnabled,
}) => {
  console.log("Allergy History called", allergyHistoryData);
  const [allergyVars, setAllergyVars] = useState({
    allergy_type: null,
    allergy_description: "",
    note: "",
    allergy_code: null,
    clinical_status_description: "Active",
    condition_onset: "",
    condition_onset_type: "days",
    condition_duration: "",
    condition_duration_type: "days",
    onset_datetime: null,
    abatement_datetime: null,
  });
  const [drugName, setDrugName] = useState("");
  const [allergyEditIndex, setAllergyEditIndex] = useState(null);
  const [allergyError, setAllergyError] = useState("");

  const handleAddAllergyRow = async () => {
    if (
      (allergyVars.allergy_description || drugName.length > 0) &&
      allergyVars.allergy_type
    ) {
      // Store the updated state in a local variable
      let newRow;

      let newDetails = {
        ...allergyVars,
        id: null,
      };
      console.log("allergyVars", allergyVars);
      newRow = {
        allergy_type: newDetails.allergy_type,
        allergy_description: newDetails.allergy_description,
        note: newDetails.note,
        clinical_status_description: newDetails.clinical_status_description,
        condition_onset: newDetails.condition_onset,
        condition_onset_type: newDetails.condition_onset_type,
        condition_duration: newDetails.condition_duration,
        condition_duration_type: newDetails.condition_duration_type,
        onset_datetime: newDetails?.onset_datetime
          ? dayjs(newDetails.onset_datetime).format("YYYY-MM-DD")
          : null,
        abatement_datetime: newDetails?.abatement_datetime
          ? dayjs(newDetails.abatement_datetime).format("YYYY-MM-DD")
          : null,
      };

      console.log("newRow", newRow);

      // Update family history rows by adding the new row

      const updatedRows = [...allergyHistoryData["new"], newRow];

      setAllergyHistoryData({
        ...allergyHistoryData,
        new: updatedRows,
      });
      // Reset family history variables and clear error
      setAllergyVars({
        allergy_type: allergyVars.allergy_type,
        allergy_description: "",
        note: "",
        allergy_code: null,
        clinical_status_description: "Active",
        condition_onset: "",
        condition_onset_type: "days",
        condition_duration: "",
        condition_duration_type: "days",
        onset_datetime: null,
        abatement_datetime: null,
      });
      setDrugName("");
      setAllergyError("");
    } else {
      // Set error message if any field is missing
      setAllergyError("Allergy Description and Allergy Type is required");
    }
  };
  const handleAllergyEditClick = (row, rowIndex) => {
    if (row.allergy_type == "medication") {
      setDrugName(row.allergy_description);
    }
    setAllergyVars({
      allergy_type: row.allergy_type,
      allergy_description:
        row.allergy_type == "medication" ? "" : row.allergy_description,
      note: row.note,
      allergy_code: row.allergy_code,
      clinical_status_description: row.clinical_status_description,
      condition_onset: row?.condition_onset || "",
      condition_onset_type: row?.condition_onset_type || "days",
      condition_duration: row?.condition_duration || "",
      condition_duration_type: row?.condition_duration_type || "days",
      onset_datetime: row?.onset_datetime ? dayjs(row.onset_datetime) : null,
      abatement_datetime: row?.abatement_datetime
        ? dayjs(row.abatement_datetime)
        : null,
    });
    setAllergyEditIndex(rowIndex);
  };
  const handleAllergyUpdate = async () => {
    if (
      (allergyVars.allergy_description || drugName.length > 0) &&
      allergyVars.allergy_type
    ) {
      // Store the updated state in a local variable
      let updatedRow, newDetails;

      newDetails = { ...allergyVars, source: undefined };
      updatedRow = {
        allergy_type: newDetails.allergy_type,
        allergy_description: newDetails.allergy_description,
        note: newDetails.note,
        clinical_status_description: newDetails.clinical_status_description,
        condition_onset: newDetails.condition_onset,
        condition_onset_type: newDetails.condition_onset_type,
        condition_duration: newDetails.condition_duration,
        condition_duration_type: newDetails.condition_duration_type,
        onset_datetime: newDetails?.onset_datetime
          ? dayjs(newDetails.onset_datetime).format("YYYY-MM-DD")
          : null,
        abatement_datetime: newDetails?.abatement_datetime
          ? dayjs(newDetails.abatement_datetime).format("YYYY-MM-DD")
          : null,
      };

      const updatedAllergy = allergyHistoryData["new"].map((row, index) => {
        if (index === allergyEditIndex) {
          return updatedRow;
        } else {
          return row;
        }
      });
      setAllergyHistoryData({
        ...allergyHistoryData,
        new: updatedAllergy,
      });
      // Reset family history variables and clear error
      setAllergyVars({
        allergy_type: allergyVars.allergy_type,
        allergy_description: "",
        note: "",
        allergy_code: null,
        clinical_status_description: "Active",
        condition_onset: "",
        condition_onset_type: "days",
        condition_duration: "",
        condition_duration_type: "days",
        onset_datetime: null,
        abatement_datetime: null,
      });
      setAllergyEditIndex(null);
      setAllergyError("");
      setDrugName("");
    } else {
      // Set error message if any field is missing
      setAllergyError("Allergy Description and Allergy Type is required");
    }
  };
  const handleAllergyDelete = (rowIndex) => {
    // Filter out the row at the specified index
    const updatedAllergy = allergyHistoryData["new"].filter(
      (row, index) => index !== rowIndex
    );
    // Update the state with the filtered array
    setAllergyHistoryData({
      ...allergyHistoryData,
      new: updatedAllergy,
    });
  };
  const calculateOnsetDate = (duration, type) => {
    if (!duration || isNaN(parseInt(duration, 10))) return null;
    const today = dayjs();
    const durationMap = {
      minutes: "minute",
      hours: "hour",
      days: "day",
      weeks: "week",
      months: "month",
      years: "year",
    };
    return today.subtract(duration, durationMap[type]);
  };

  const calculateAbatementDate = (onset_datetime, duration, type) => {
    if (!duration || isNaN(parseInt(duration, 10)) || !onset_datetime)
      return null;
    const durationMap = {
      minutes: "minute",
      hours: "hour",
      days: "day",
      weeks: "week",
      months: "month",
      years: "year",
    };
    return dayjs(onset_datetime).add(duration, durationMap[type]);
  };

  const handleChangeAllergy = (field, value) => {
    let updatedDetails = { ...allergyVars, [field]: value };

    if (
      (field === "condition_onset" || field === "condition_onset_type") &&
      updatedDetails.condition_onset &&
      updatedDetails.condition_onset_type
    ) {
      updatedDetails.onset_datetime =
        calculateOnsetDate(
          parseInt(updatedDetails.condition_onset, 10),
          updatedDetails.condition_onset_type
        ) ?? null;
      if (
        updatedDetails.condition_duration &&
        updatedDetails.condition_duration_type
      ) {
        updatedDetails.abatement_datetime =
          calculateAbatementDate(
            updatedDetails.onset_datetime,
            parseInt(updatedDetails.condition_duration, 10),
            updatedDetails.condition_duration_type
          ) ?? null;
      }
    } else if (
      field === "condition_onset" ||
      field === "condition_onset_type"
    ) {
      updatedDetails.onset_datetime = null;
    }

    if (
      (field === "condition_duration" ||
        field === "condition_duration_type") &&
      updatedDetails.condition_duration &&
      updatedDetails.condition_duration_type
    ) {
      updatedDetails.abatement_datetime =
        calculateAbatementDate(
          updatedDetails.onset_datetime,
          parseInt(updatedDetails.condition_duration, 10),
          updatedDetails.condition_duration_type
        ) ?? null;
    } else if (
      field === "condition_duration" ||
      field === "condition_duration_type"
    ) {
      updatedDetails.abatement_datetime = null;
    }

    setAllergyVars(updatedDetails);
  };
  const handleClearAllergyDescription = () => {
    setAllergyError("");
    setDrugName("");
    setAllergyVars({
      ...allergyVars,
      allergy_description: "", // Use computed property name to set the field dynamically
    });
  };

  //   const handleAddOption = async (term) => {
  //     const postBody = {
  //       term: term,
  //       state: "active",
  //       semantictag: "real clinical drug++clinical drug",
  //       acceptability: "synonyms",
  //       returnlimit: "-1",
  //       refsetid: null,
  //       parentid: null,
  //       excludeparentconcept: false,
  //       fullconcept: true,
  //     };

  //     try {
  //       if (drugName.length > 2) {
  //         const response = await axios.post(
  //           `${REACT_APP_BACKEND_ROUTE_URL}snomed/search/`,
  //           postBody,
  //           { headers: headers }
  //         );
  //         if (response) {
  //           let updatedFound = {},
  //             updatedSelectedOptiondetsils = {},
  //             foundData = false;
  //           console.log("Snomed Response", response);
  //           if (
  //             response.data.status === "Success" &&
  //             response.data.data.length > 0
  //           ) {
  //             foundData = response.data.data.find((d) => d.term === term);
  //             console.log("Found Data", foundData);
  //             if (foundData) {
  //               updatedFound = {
  //                 ...foundData,
  //                 found: true,
  //                 id: foundData.conceptId,
  //               };
  //             } else {
  //               updatedSelectedOptiondetsils = {
  //                 hierarchy: null,
  //                 isPreferredTerm: null,
  //                 conceptState: null,
  //                 conceptFsn: term,
  //                 definitionStatus: null,
  //                 conceptId: null,
  //                 languageCode: "en",
  //                 typeId: null,
  //                 term: term,
  //                 caseSignificanceId: "CASE_INSENSITIVE",
  //                 id: null,
  //                 effectiveTime: null,
  //                 activeStatus: null,
  //                 moduleId: null,
  //               };
  //             }
  //           } else {
  //             updatedSelectedOptiondetsils = {
  //               hierarchy: null,
  //               isPreferredTerm: null,
  //               conceptState: null,
  //               conceptFsn: term,
  //               definitionStatus: null,
  //               conceptId: null,
  //               languageCode: "en",
  //               typeId: null,
  //               term: term,
  //               caseSignificanceId: "CASE_INSENSITIVE",
  //               id: null,
  //               effectiveTime: null,
  //               activeStatus: null,
  //               moduleId: null,
  //             };
  //           }

  //           setAutoCompleteData([]);
  //           setFilteredOptions([]);
  //           setSuggestApiCalled(false);
  //           setDebounceFunctionCalled(true);
  //           if (foundData) {
  //             handleChangeAllergy("allergy_description", updatedFound.term);
  //           } else {
  //             handleChangeAllergy(
  //               "allergy_description",
  //               updatedSelectedOptiondetsils.term
  //             );
  //           }
  //         }
  //       }
  //     } catch (err) {
  //       console.log(err);
  //       toast.error(err);
  //     }
  //   };

  const handleConditionTyped = (value) => {
    setDrugName(value);
    handleChangeAllergy("allergy_description", value);
  };

  return (
    <ThemeProvider theme={theme}>
      <Card
        sx={{
          borderRadius: "10px",
          boxShadow: "0 4px 4px 0 #C7C7CC inset",
          backgroundColor: "#FFF",
        }}
      >
        <Grid container spacing={2} sx={{ margin: "5px 0px", display: "flex" }}>
          <Grid item xs={11} sm={2} sx={{ margin: "5px 0px" }}>
            {/* <FormControl fullWidth> */}
            {/* <StyledInputLabel>Select Type</StyledInputLabel> */}
            <StyledTextField
              select
              label="Select Type"
              value={allergyVars.allergy_type}
              onChange={(e) =>
                handleChangeAllergy("allergy_type", e.target.value)
              }
              fullWidth
            >
              {["Food", "Medication", "Environment", "Biologic"].map((type) => (
                <MenuItem
                  key={type}
                  value={type.toLocaleLowerCase()}
                  sx={{ fontSize: "12px" }}
                >
                  {type}
                </MenuItem>
              ))}
            </StyledTextField>
            {/* </FormControl> */}
          </Grid>
          <Grid
            item
            xs={11}
            sm={6}
            sx={{ margin: "5px 0px", position: "relative" }}
          >
            <StyledTextField
              fullWidth
              label="Allergy Description"
              value={
                allergyVars.allergy_type == "medication"
                  ? // allergyVars.allergy_description !== ""
                    //   ? allergyVars.allergy_description
                    //   :
                    drugName
                  : allergyVars.allergy_description
              }
              onChange={(e) =>
                allergyVars.allergy_type == "medication"
                  ? // ? setDrugName(e.target.value)
                    handleConditionTyped(e.target.value)
                  : handleChangeAllergy("allergy_description", e.target.value)
              }
              InputProps={{
                endAdornment: (
                  <div style={{ display: "flex", justifyContent: "flex-end" }}>
                    <div style={{ marginRight: "5px" }}>
                      <Tooltip title="Clear">
                        <OutlinedIconFab
                          size="small"
                          variant="contained"
                          onClick={handleClearAllergyDescription}
                        >
                          <Icon name="clearTextField" size={32} />
                        </OutlinedIconFab>
                      </Tooltip>
                    </div>
                  </div>
                ),
              }}
            />
          </Grid>

          <Grid item xs={11} sm={3} sx={{ margin: "5px 0px" }}>
            {/* <FormControl fullWidth> */}
            {/* <StyledInputLabel>Select Clinical Status</StyledInputLabel> */}
            <StyledTextField
              select
              label="Select Clinical Status"
              value={allergyVars.clinical_status_description}
              onChange={(e) =>
                handleChangeAllergy(
                  "clinical_status_description",
                  e.target.value
                )
              }
              fullWidth
            >
              {["Active", "Inactive", "Resolved"].map((relation) => (
                <MenuItem
                  key={relation}
                  value={relation}
                  sx={{ fontSize: "12px" }}
                >
                  {relation}
                </MenuItem>
              ))}
            </StyledTextField>
            {/* </FormControl> */}
          </Grid>
          <Grid item xs={11} sm={11} sx={{ margin: "5px 0px" }}>
            <StyledTextField
              fullWidth
              label="Note"
              value={allergyVars.note}
              onChange={(e) => handleChangeAllergy("note", e.target.value)}
            />
          </Grid>

          <Grid item xs={6} sm={6} md={2} style={{ display: "flex" }}>
            <Tooltip title="How long ago this allergy started">
              <span
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                }}
              >
                Allergy Onset:
              </span>
            </Tooltip>
            <StyledTextField
              label="Duration"
              fullWidth
              type="number"
              value={allergyVars.condition_onset || ""}
              onChange={(e) =>
                handleChangeAllergy("condition_onset", e.target.value)
              }
              onWheel={(e) => e.target.blur()}
              InputProps={{
                inputProps: { style: { MozAppearance: "textfield" } },
                sx: {
                  "& input[type=number]": { MozAppearance: "textfield" },
                  "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button":
                    { WebkitAppearance: "none", margin: 0 },
                },
              }}
            />
          </Grid>

          <Grid item xs={6} sm={5} md={2.5}>
            <StyledTextField
              select
              fullWidth
              label="Duration Type"
              value={allergyVars.condition_onset_type || "days"}
              onChange={(e) =>
                handleChangeAllergy("condition_onset_type", e.target.value)
              }
            >
              {durationType.map((type) => (
                <MenuItem
                  key={type.value}
                  value={type.value}
                  sx={{ fontSize: "12px" }}
                >
                  {type.display}
                </MenuItem>
              ))}
            </StyledTextField>
          </Grid>

          <Grid item xs={6} sm={6} md={2} style={{ display: "flex" }}>
            <Tooltip title="How long this allergy has lasted">
              <span
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                }}
              >
                Allergy Duration:
              </span>
            </Tooltip>
            <StyledTextField
              label="Duration"
              fullWidth
              type="number"
              value={allergyVars.condition_duration || ""}
              onChange={(e) =>
                handleChangeAllergy("condition_duration", e.target.value)
              }
              onWheel={(e) => e.target.blur()}
              InputProps={{
                inputProps: { style: { MozAppearance: "textfield" } },
                sx: {
                  "& input[type=number]": { MozAppearance: "textfield" },
                  "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button":
                    { WebkitAppearance: "none", margin: 0 },
                },
              }}
            />
          </Grid>

          <Grid item xs={6} sm={5} md={2.5}>
            <StyledTextField
              select
              fullWidth
              label="Duration Type"
              value={allergyVars.condition_duration_type || "days"}
              onChange={(e) =>
                handleChangeAllergy("condition_duration_type", e.target.value)
              }
            >
              {durationType.map((type) => (
                <MenuItem
                  key={type.value}
                  value={type.value}
                  sx={{ fontSize: "12px" }}
                >
                  {type.display}
                </MenuItem>
              ))}
            </StyledTextField>
          </Grid>

          <Grid
            item
            xs={11}
            sm={2}
            sx={{
              margin: "5px 0px",
              display: "flex",
              justifyContent: "flex-end",
              padding: "0px",
            }}
          >
            <StyledButton
              bgColor="#0E3F66"
              variant="contained"
              fullWidth
              onClick={
                allergyEditIndex !== null
                  ? handleAllergyUpdate
                  : handleAddAllergyRow
              }
              color="defaultColor"
            >
              {allergyEditIndex !== null ? "Update" : "Add"}
            </StyledButton>
          </Grid>
          {allergyError && (
            <Typography style={{ color: "red" }}>{allergyError}</Typography>
          )}
          <Grid item xs={11} sm={11}>
            {allergyHistoryData["prev"].length > 0 && (
              <StyledTableContainer
                component={Paper}
                // sx={{
                //   marginTop: "20px",
                //   border: "1px solid #21cdc0",
                // }}
              >
                <Table>
                  <TableHead>
                    <StyledTableRowHistory>
                      <StyledTableCellHistory>
                        Allergy Type
                      </StyledTableCellHistory>
                      <StyledTableCellHistory>
                        Allergy Description
                      </StyledTableCellHistory>
                      <StyledTableCellHistory>Note</StyledTableCellHistory>
                      <StyledTableCellHistory>
                        Allergy Onset
                      </StyledTableCellHistory>
                      <StyledTableCellHistory>
                        Allergy Duration
                      </StyledTableCellHistory>
                      <StyledTableCellHistory>
                        Clinical Status
                      </StyledTableCellHistory>
                      <StyledTableCellHistory>Action</StyledTableCellHistory>
                    </StyledTableRowHistory>
                  </TableHead>
                  <TableBody>
                    {allergyHistoryData["prev"].map((row, rowIndex) => {
                      // console.log("Allergy Row", row); // Logging the row object

                      return (
                        <StyledTableRowHistory key={rowIndex}>
                          <StyledTableCellHistory>
                            {row?.allergy_type
                              ? row.allergy_type.charAt(0).toUpperCase() +
                                row.allergy_type.slice(1)
                              : "-"}
                          </StyledTableCellHistory>
                          <StyledTableCellHistory>
                            {row?.allergy_description}
                          </StyledTableCellHistory>
                          <StyledTableCellHistory>
                            {row?.note === "" ? "-" : row?.note}
                          </StyledTableCellHistory>
                          <StyledTableCellHistory>
                            {row?.condition_onset
                              ? `${row.condition_onset} ${row.condition_onset_type} ago`
                              : "-"}
                          </StyledTableCellHistory>
                          <StyledTableCellHistory>
                            {row?.condition_duration
                              ? `${row.condition_duration} ${row.condition_duration_type}`
                              : "-"}
                          </StyledTableCellHistory>
                          <StyledTableCellHistory>
                            {row?.clinical_status_description === ""
                              ? "-"
                              : row?.clinical_status_description}
                          </StyledTableCellHistory>
                          <StyledTableCellHistory>-</StyledTableCellHistory>
                        </StyledTableRowHistory>
                      );
                    })}
                  </TableBody>
                </Table>
              </StyledTableContainer>
            )}
          </Grid>
          <Grid item xs={11} sm={11}>
            {allergyHistoryData["new"].length > 0 && (
              <StyledTableContainer
                component={Paper}
                // sx={{
                //   marginTop: "20px",
                //   border: "1px solid #21cdc0",
                // }}
              >
                <Table>
                  <TableHead>
                    <StyledTableRowHistory>
                      <StyledTableCellHistory>
                        Allergy Type
                      </StyledTableCellHistory>
                      <StyledTableCellHistory>
                        Allergy Description
                      </StyledTableCellHistory>
                      <StyledTableCellHistory>Note</StyledTableCellHistory>
                      <StyledTableCellHistory>
                        Allergy Onset
                      </StyledTableCellHistory>
                      <StyledTableCellHistory>
                        Allergy Duration
                      </StyledTableCellHistory>
                      <StyledTableCellHistory>
                        Clinical Status
                      </StyledTableCellHistory>
                      <StyledTableCellHistory>Action</StyledTableCellHistory>
                    </StyledTableRowHistory>
                  </TableHead>
                  <TableBody>
                    {allergyHistoryData["new"].map((row, rowIndex) => {
                      console.log("Allergy Row", row); // Logging the row object

                      return (
                        <StyledTableRowHistory key={rowIndex}>
                          <StyledTableCellHistory>
                            {row?.allergy_type.charAt(0).toUpperCase() +
                              row?.allergy_type.slice(1)}
                          </StyledTableCellHistory>
                          <StyledTableCellHistory>
                            {row?.allergy_description}
                          </StyledTableCellHistory>
                          <StyledTableCellHistory>
                            {row?.note === "" ? "-" : row?.note}
                          </StyledTableCellHistory>
                          <StyledTableCellHistory>
                            {row?.condition_onset
                              ? `${row.condition_onset} ${row.condition_onset_type} ago`
                              : "-"}
                          </StyledTableCellHistory>
                          <StyledTableCellHistory>
                            {row?.condition_duration
                              ? `${row.condition_duration} ${row.condition_duration_type}`
                              : "-"}
                          </StyledTableCellHistory>
                          <StyledTableCellHistory>
                            {row?.clinical_status_description === ""
                              ? "-"
                              : row?.clinical_status_description}
                          </StyledTableCellHistory>
                          <StyledTableCellHistory>
                            {allergyHistoryData["prev"].includes(row) ? (
                              "-"
                            ) : (
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "row",
                                }}
                              >
                                <Tooltip title="Edit">
                                  <OutlinedIconFab
                                    onClick={() =>
                                      handleAllergyEditClick(row, rowIndex)
                                    }
                                    sx={{ marginRight: 1 }}
                                  >
                                    <Icon name="editInTable" size={32} />
                                  </OutlinedIconFab>
                                </Tooltip>
                                <Tooltip title="Delete">
                                  <OutlinedIconFab
                                    onClick={() =>
                                      handleAllergyDelete(rowIndex)
                                    }
                                  >
                                    <Icon name="deleteInTable" size={32} />
                                  </OutlinedIconFab>
                                </Tooltip>
                              </div>
                            )}
                          </StyledTableCellHistory>
                        </StyledTableRowHistory>
                      );
                    })}
                  </TableBody>
                </Table>
              </StyledTableContainer>
            )}
          </Grid>
        </Grid>
      </Card>
    </ThemeProvider>
  );
};

export default AllergyIntoleranceSimplified;
